export const genList = (from, to) => {
    const list = [];
    for (let x = from; x <= to; x++) {
        list.push({ value: `${x}`, label: `${x}` });
    }
    return list;
};
